export default "__VITE_ASSET__C60t6$Df__"